import { WidgetDefinition } from '../models/WidgetDefinition';

export const DigitalSignatureWidgetDefinition: WidgetDefinition = {
    baseType: 'DigitalSignature',
    group: 'Charts',
    hasImage: true,
    highlights: ['The last approver signature', 'Only shown if date is approved for current group'],
    icon: 'fa-pencil',
    sortingOrder: 1900,
    title: 'Digital signature',
    type: 'DigitalSignature'
};